import { Home, Users, Building, Wrench, type LucideIcon } from "lucide-react";

export interface SignupFormData {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
  phoneNumber: string;
  userType: string;
  propertyAddress: string;
  propertyType: string;
  propertySubType: string;
  propertyName: string;
  propertyCity: string;
  propertyState: string;
  propertyZipCode: string;
  propertyDescription: string;
  squareFootage: string;
  numberOfUnits: string;
  yearBuilt: string;
}

export interface UserTypeOption {
  id: string;
  title: string;
  description: string;
  icon: LucideIcon;
}

export const USER_TYPES: UserTypeOption[] = [
  {
    id: "property_owner",
    title: "Property Owner",
    description: "Individual property owners",
    icon: Home,
  },
  {
    id: "home_association",
    title: "Home Association",
    description: "HOA and community management",
    icon: Users,
  },
  {
    id: "facilities_management",
    title: "Facilities Management",
    description: "Professional facility managers",
    icon: Building,
  },
  {
    id: "service_provider",
    title: "Service Provider",
    description: "Contractors and service companies",
    icon: Wrench,
  },
];

export const INITIAL_FORM_DATA: SignupFormData = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  confirmPassword: "",
  phoneNumber: "",
  userType: "",
  propertyAddress: "",
  propertyType: "",
  propertySubType: "",
  propertyName: "",
  propertyCity: "",
  propertyState: "",
  propertyZipCode: "",
  propertyDescription: "",
  squareFootage: "",
  numberOfUnits: "",
  yearBuilt: "",
};
